import { routes as app } from '../app'

const root = [
  { path: '/', redirect: '/wizard' }
]

export default [ ...root, ...app ]



// WEBPACK FOOTER //
// ./src/router/routes.js